module.exports = __webpack_public_path__ + "static/media/AiMessage1.480ae3a3.png";